var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuggageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "#546587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28355 14.9228C3.54269 15.5772 4.16615 16 4.87184 16H14.554C15.2605 16 15.8841 15.5766 16.1429 14.9213C16.4391 14.1713 17.2192 11.9729 17.9541 9.91016H1.4707C2.20288 11.967 2.98199 14.1613 3.28355 14.9228Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3299 5.43012C19.2239 5.27489 19.0477 5.18192 18.8594 5.18192H13.433V7.26229C13.433 7.57563 13.1782 7.82966 12.8638 7.82966C12.5495 7.82966 12.2946 7.57563 12.2946 7.26229V5.18192H7.13394V7.26229C7.13394 7.57563 6.87909 7.82966 6.56474 7.82966C6.2504 7.82966 5.99555 7.57563 5.99555 7.26229V5.18192H0.569217C0.381041 5.18192 0.205008 5.27462 0.0989861 5.42959C-0.00707404 5.58456 -0.0294245 5.78178 0.0392964 5.95642C0.225196 6.42908 0.615246 7.51144 1.06635 8.77529H18.359C18.809 7.51647 19.1993 6.43638 19.3888 5.95752C19.458 5.78284 19.4359 5.58536 19.3299 5.43012Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13351 3.70689C7.13351 2.2886 8.29106 1.13475 9.71386 1.13475C11.1367 1.13475 12.2942 2.2886 12.2942 3.70689V5.18202H13.4326V3.70689C13.4326 1.6629 11.7644 0 9.71386 0C7.66335 0 5.99512 1.6629 5.99512 3.70689V5.18202H7.13351V3.70689Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageIcon);
export default __webpack_public_path__ + "static/media/luggage_icon.0cac94a3ac76d6deacc40838752741e9.svg";
export { ForwardRef as ReactComponent };